export const cymbioColors = {
  black: 'rgba(20, 19, 58, 1)',
  lightBlack: 'rgba(20, 19, 58, 0.6)',
  analytics: {
    totalBlack: '#000',
    black: '#33243b',
    pink: '#e84692',
    darkBlue: '#312E4B',
    darkGray: '#586271',
    darkGreen: '#005e36',
    darkRed: '#800c0c',

    textPrimary: '#292929',
    textSecondary: '#767676',

    lime: '#9df2aa',
    ruby: '#ff8b86',
    sunset: '#fcbf85',
  },
};
